import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Loading } from "@/components/common/Primitives";
import { Radio, Layers, Percent, Calculator, Clock, AlertTriangle } from "lucide-react";

function Kpi({ icon: Icon, label, value, to, testid, tone = "" }) {
  const body = (
    <div className="rounded-lg border border-border bg-card p-4 shadow-sm transition-colors hover:bg-muted/40" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</span>
        <Icon className={`h-4 w-4 ${tone || "text-muted-foreground"}`} />
      </div>
      <div className="mt-2 text-2xl font-semibold text-foreground">{value}</div>
    </div>
  );
  return to ? <Link to={to}>{body}</Link> : body;
}

export default function MfOverview() {
  const { data, isLoading } = useQuery({ queryKey: ["mf-overview"], queryFn: async () => (await api.get("/mobilfunk/overview")).data });
  if (isLoading) return <Loading />;
  const d = data || {};
  return (
    <div data-testid="mf-overview">
      <PageHeader title="Mobilfunk & Provisionen" description="Übersicht der Stammdaten und offenen Freigaben (Phase 1)." />
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Kpi icon={Radio} label="Anbieter" value={d.providers_total ?? 0} to="/mobilfunk/anbieter" testid="kpi-providers" />
        <Kpi icon={Radio} label="Distributoren" value={d.distributors_total ?? 0} to="/mobilfunk/anbieter" testid="kpi-distributors" />
        <Kpi icon={Layers} label="Aktive Tarife" value={d.tariffs_active ?? 0} to="/mobilfunk/tarife" testid="kpi-tariffs" />
        <Kpi icon={Clock} label="Auslaufende Versionen (30 T.)" value={d.tariff_versions_expiring ?? 0} to="/mobilfunk/tarife" testid="kpi-expiring" tone={d.tariff_versions_expiring ? "text-amber-500" : ""} />
        <Kpi icon={Percent} label="Aktive Aktionen" value={d.promotions_active ?? 0} to="/mobilfunk/aktionen" testid="kpi-promotions" />
        <Kpi icon={Calculator} label="Aktive Provisionsmodelle" value={d.commission_rules_active ?? 0} to="/mobilfunk/provisionsmodelle" testid="kpi-rules" />
        <Kpi icon={AlertTriangle} label="Offene Freigaben" value={d.pending_approvals ?? 0} testid="kpi-approvals" tone={d.pending_approvals ? "text-amber-500" : ""} />
      </div>
      <div className="mt-6 rounded-lg border border-dashed border-border bg-card/40 p-4 text-sm text-muted-foreground" data-testid="mf-phase-note">
        {d.phase_note || "Vertragsabschlüsse, Provisionen & Abrechnungen folgen in den nächsten Phasen."}
      </div>
    </div>
  );
}
